/*
 * @Author: your name
 * @Date: 2022-04-19 00:56:33
 * @LastEditTime: 2022-04-19 14:38:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \rcd-wap\src\filters\time-filter.ts
 */
import Vue from 'vue'
import ConvertService  from "../utils/convert-service"

// 保留小数位
Vue.filter('NumberToChinese', (value)=> {
    return ConvertService.NumberToChinese(value)
})